import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export const FaqSection: React.FC = () => {
  const [openIndexes, setOpenIndexes] = useState<number[]>([]);
  const toggle = (index: number) => {
    setOpenIndexes(current => current.includes(index) ? current.filter(i => i !== index) : [...current, index]);
  };
  return <section id="faqs" aria-labelledby="faqs-heading" className="section-y bg-white" data-id="element-51" data-mp="248y00czwkyb9">
      <div className="section-container" data-id="element-52" data-mp="28bb46wz04o5x">
        <div className="mx-auto max-w-3xl" data-id="element-53" data-mp="28a9twupt85p9">
          <h2 id="faqs-heading" className="section-heading" data-id="element-54" data-mp="1ujmroskubxof">
            Frequently asked questions
          </h2>
          <div className="mt-8 border-t border-mist-sage/70 md:mt-10" data-id="element-55" data-mp="1zhy5fee9asbx">
            {faqs.map((faq, index) => {
            const isOpen = openIndexes.includes(index);
            const buttonId = `faq-button-${index}`;
            const panelId = `faq-panel-${index}`;
            return <div key={faq.question} className="border-b border-mist-sage/70" data-id="element-56" data-mp="14usd8uiie6ra" data-mpi={index}>
                  <h3 className="font-inter text-base" data-id="element-57" data-mp="10tyro7sjh41k">
                    <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => toggle(index)} className="flex w-full items-center justify-between gap-6 rounded-md py-5 text-left text-lg font-medium text-deep-juniper" data-id="element-58" data-mp="10vjne0qlat10">
                      {faq.question}
                      <ChevronDownIcon size={20} aria-hidden="true" className={`flex-shrink-0 text-plum-gray transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-59" data-mp="1xkhjbma2swzr" />
                    </button>
                  </h3>
                  <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!isOpen} className="pb-6 pr-10" data-id="element-60" data-mp="3udazy49z9h0a">
                    <p className="leading-relaxed text-plum-gray" data-id="element-61" data-mp="23aaehkq5gd28">{faq.answer}</p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
};